import { useWSModal } from "@wingspanhq/fe-component-library";
import { CreateEngagementModal } from "./index";

export function useCreatePayeeEngagementModal() {
  return useWSModal(CreateEngagementModal, {
    title: "Add assignments",
    size: "S"
  });
}
